import React, { useState } from 'react';


import DeleteConfirmationModal from '../../../components/ui/DeleteConfirmationModal';

const DeleteClientModal = ({ client, onClose, onConfirm }) => {
  return (
    <DeleteConfirmationModal
      isOpen={!!client}
      onClose={onClose}
      onConfirm={() => onConfirm(client?.id)}
      itemName={client?.companyName}
      itemType="Client"
      additionalInfo=""
      warningMessage={
        <>
          This action <strong>cannot be undone</strong>. This will permanently delete
          <strong className="text-destructive"> "{client?.companyName}"</strong>.
          <div className="mt-2 text-xs">
            Note: Projects associated with this client will not be deleted, but the client reference will be removed.
          </div>
        </>
      }
    />
  );
};

export default DeleteClientModal;